export const DT_MONITORING_CONTEXT_KEY = '__EXO_DT_MONITORING_CONTEXT__';

window[DT_MONITORING_CONTEXT_KEY] = {};

export const getDTMonitoringContext = () =>
  window[DT_MONITORING_CONTEXT_KEY] || {};

export function setToDTWindowMonitoringContext(key: string, value: unknown) {
  try {
    if (!window[DT_MONITORING_CONTEXT_KEY]) return;

    if (
      value === null ||
      ['string', 'number', 'boolean', 'undefined'].includes(typeof value)
    ) {
      window[DT_MONITORING_CONTEXT_KEY][key] = value as
        | string
        | number
        | boolean
        | null
        | undefined;
      return;
    }

    // value is an object
    window[DT_MONITORING_CONTEXT_KEY][key] = JSON.stringify(value);
  } catch (e) {
    console.error(
      `Failed to set ${key} to dynatrace window monitoring context: ${e}`,
    );
  }
}

export function deleteFromDTWindowMonitoringContext(key: string) {
  try {
    if (!window[DT_MONITORING_CONTEXT_KEY]) return;

    delete window[DT_MONITORING_CONTEXT_KEY][key];
  } catch (e) {
    console.error(
      `Failed to remove ${key} from dynatrace window monitoring context: ${e}`,
    );
  }
}
